module.exports = __webpack_public_path__ + "static/media/blackTriangle.325820db.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App/blackTriangle.svg
 ** module id = 625
 ** module chunks = 0
 **/